module.exports = __webpack_public_path__ + "d67b1573cf762a8e5e1029b0b3aa2cd7.ttf";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-bold-webfont.ttf
// module id = 310
// module chunks = 0